import {
	TCreateGameSelectedItem,
	TCreateGameVisibleForm,
	TSourceUrlLocally,
	TTypeOfCreateGameModalWindow,
} from './createGameContext';
import {
	IItemForGetShortInfo,
	TFileId,
	TLanguageIDs,
	IFileData,
	IServerError,
	IGameApplicationIdValidationError,
	ICreateGame,
	IGameTranslation,
} from 'types';

export enum CreateGameActionTypes {
	CHANGE_VISIBLE_FORM = 'CHANGE_VISIBLE_FORM',
	SET_FILE = 'SET_FILE',
	SET_FETCHED_DEVELOPERS = 'SET_FETCHED_DEVELOPERS',
	SET_ID_DEVELOPER = 'SET_ID_DEVELOPER',
	REFETCH_DEVELOPERS = 'REFETCH_DEVELOPERS',
	SET_FETCHED_CATEGORIES = 'SET_FETCHED_CATEGORIES',
	SET_ID_CATEGORY = 'SET_ID_CATEGORY',
	CHANGE_APPLICATION_ID = 'CHANGE_APPLICATION_ID',
	CHANGE_NAME = 'CHANGE_NAME',
	CHANGE_VERSION_CODE = 'CHANGE_VERSION_CODE',
	CHANGE_VERSION_NAME = 'CHANGE_VERSION_NAME',
	CHANGE_DESCRIPTION = 'CHANGE_DESCRIPTION',
	CHANGE_APP_STORE_LINK = 'CHANGE_APP_STORE_LINK',
	CHANGE_PLAY_MARKET_LINK = 'CHANGE_PLAY_MARKET_LINK',
	CHANGE_FILE_DATA = 'CHANGE_FILE_DATA',
	SET_FETCHED_LANGUAGES = 'SET_FETCHED_LANGUAGES',
	SET_IDs_LANGUAGES = 'SET_IDs_LANGUAGES',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SHOW_ERROR_MODAL_WITH_INFO = 'SHOW_ERROR_MODAL_WITH_INFO',
	SET_TRANSLATION_TAB = 'SET_TRANSLATION_TAB',
	SET_TRANSLATION_FIELDS = 'SET_TRANSLATION_FIELDS',
	CHANGE_TRANSLATION = 'CHANGE_TRANSLATION',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface IChangeVisibleForm {
	type: CreateGameActionTypes.CHANGE_VISIBLE_FORM;
	payload: {
		visibleForm: TCreateGameVisibleForm;
	};
}

interface ISetFile {
	type: CreateGameActionTypes.SET_FILE;
	payload: {
		fileId: TFileId;
		sourceUrlLocally: TSourceUrlLocally;
	};
}

interface ISetFetchedDevelopers {
	type: CreateGameActionTypes.SET_FETCHED_DEVELOPERS;
	payload: {
		developers: IItemForGetShortInfo[];
	};
}

interface ISetIDDeveloper {
	type: CreateGameActionTypes.SET_ID_DEVELOPER;
	payload: {
		IDDeveloper: TCreateGameSelectedItem;
	};
}

interface IRefetchDevelopers {
	type: CreateGameActionTypes.REFETCH_DEVELOPERS;
	payload: {
		needRefetch: boolean;
	};
}

interface ISetFetchedCategories {
	type: CreateGameActionTypes.SET_FETCHED_CATEGORIES;
	payload: {
		categories: IItemForGetShortInfo[];
	};
}

interface ISetIDCategory {
	type: CreateGameActionTypes.SET_ID_CATEGORY;
	payload: {
		IDCategory: TCreateGameSelectedItem;
	};
}

interface IChangeApplicationId {
	type: CreateGameActionTypes.CHANGE_APPLICATION_ID;
	payload: {
		applicationId: string;
	};
}

interface IChangeName {
	type: CreateGameActionTypes.CHANGE_NAME;
	payload: {
		name: string;
	};
}

interface IChangeVersionCode {
	type: CreateGameActionTypes.CHANGE_VERSION_CODE;
	payload: {
		versionCode: string;
	};
}

interface IChangeVersionName {
	type: CreateGameActionTypes.CHANGE_VERSION_NAME;
	payload: {
		versionName: string;
	};
}

interface IChangeDescription {
	type: CreateGameActionTypes.CHANGE_DESCRIPTION;
	payload: {
		description: string;
	};
}

interface IChangeAppStoreLink {
	type: CreateGameActionTypes.CHANGE_APP_STORE_LINK;
	payload: {
		appStoreLink: string;
	};
}

interface IChangePlayMarketLink {
	type: CreateGameActionTypes.CHANGE_PLAY_MARKET_LINK;
	payload: {
		playMarketLink: string;
	};
}

interface IChangeFileHash {
	type: CreateGameActionTypes.CHANGE_FILE_DATA;
	payload: {
		fileData: IFileData;
	};
}

interface ISetFetchedLanguages {
	type: CreateGameActionTypes.SET_FETCHED_LANGUAGES;
	payload: {
		languages: IItemForGetShortInfo[];
	};
}

interface ISetIDsLanguages {
	type: CreateGameActionTypes.SET_IDs_LANGUAGES;
	payload: {
		IDsLanguages: TLanguageIDs[];
	};
}

interface ISetDataForSubmit {
	type: CreateGameActionTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		data: ICreateGame | null;
	};
}

interface IChangeTypeOfModalWindow {
	type: CreateGameActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfCreateGameModalWindow;
	};
}

interface IShowErrorModalWithInfo {
	type: CreateGameActionTypes.SHOW_ERROR_MODAL_WITH_INFO;
	payload: {
		errorResponseData: IServerError<IGameApplicationIdValidationError> | null;
	};
}

interface ISetTranslationTab {
	type: CreateGameActionTypes.SET_TRANSLATION_TAB;
	payload: {
		translationTab: TLanguageIDs | null;
	};
}

interface ISetTranslationFields {
	type: CreateGameActionTypes.SET_TRANSLATION_FIELDS;
	payload: {
		updatedTranslations: IGameTranslation[];
	};
}

interface IChangeTranslation {
	type: CreateGameActionTypes.CHANGE_TRANSLATION;
	payload: {
		updatedTranslations: IGameTranslation[];
	};
}

interface IResetSelectedControls {
	type: CreateGameActionTypes.RESET_FIELDS;
}

export type TCreateGameAction =
	| IChangeVisibleForm
	| ISetFile
	| ISetFetchedDevelopers
	| ISetIDDeveloper
	| IRefetchDevelopers
	| ISetFetchedCategories
	| ISetIDCategory
	| IChangeApplicationId
	| IChangeName
	| IChangeVersionCode
	| IChangeVersionName
	| IChangeDescription
	| IChangeAppStoreLink
	| IChangePlayMarketLink
	| IChangeFileHash
	| ISetFetchedLanguages
	| ISetIDsLanguages
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow
	| IShowErrorModalWithInfo
	| ISetTranslationTab
	| ISetTranslationFields
	| IChangeTranslation
	| IResetSelectedControls;
